import LoupeIcon from '@/frontend/components/icons/LoupeIcon';
import SpinnerComponent from '@/frontend/components/SpinnerComponent';
import SearchApi from '@/frontend/api/search';
export default {
  name: "SearchComponent",
  components: {
    LoupeIcon,
    SpinnerComponent
  },

  data() {
    return {
      searchName: '',
      searchResult: [],
      loading: false,
      timeoutId: 0
    };
  },

  watch: {
    '$route.query.q'() {
      this.searchName = this.$route.query.q || '';
      !this.searchName && (this.searchResult = []);
    }

  },
  methods: {
    search() {
      clearTimeout(this.timeoutId);
      this.searchResult = [];
      if (!this.searchName) return;
      this.loading = true;
      this.timeoutId = setTimeout(() => {
        SearchApi.get({
          'filter[name][like]': this.searchName
        }).then(response => this.searchResult = response).catch(error => {
          console.error(error);
        }).finally(() => this.loading = false);
      }, 1000);
    },

    getToForRouterLink(item) {
      if (item.type === 'Автор') return {
        name: 'author',
        params: {
          id: item.id
        }
      };else if (item.type === 'Работа') return {
        name: 'work',
        params: {
          id: item.id
        }
      };else if (item.type === 'Подборка') return {
        name: 'compilation',
        params: {
          id: item.id
        }
      };
      return '';
    }

  }
};